const GOOGLE_TRACKING_ID = 'UA-139061716-1';

export default GOOGLE_TRACKING_ID;
